import { render } from "./section-plain-text.html?vue&type=template&id=207e12e6"
import script from "./section-plain-text.js?vue&type=script&lang=js"
export * from "./section-plain-text.js?vue&type=script&lang=js"

import "./section-plain-text.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__